import { modelT } from "../../redux/features/ui/ui.types";

export const modelsOttomans: modelT[] = [
  //Minsky Set was removed from January 22 2025
  // {
  //   img: "/images/assets/ClassicSofa/Ottoman.png",
  //   label: "Minsky Set",
  //   nameValueThreekit: "Minsky Ottomans",
  //   subcategory: "Ottomans",
  // },
  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Haxel Storage Footstool",
    labelUI: "Haxel Storage Footstool",
    nameValueThreekit: "Haxel Storage Footstool",
    subcategory: "Ottomans",
  },
  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Dixy Storage Footstool",
    labelUI: "Dixy Storage Footstool",
    nameValueThreekit: "Dixy Storage Footstool",
    subcategory: "Ottomans",
  },
  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Bell Storage Ottoman",
    labelUI: "Bell Storage Ottoman",
    nameValueThreekit: "Bell Storage Ottoman",
    subcategory: "Ottomans",
  },

  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Medium Rectangle",
    labelUI: "Medium Rectangle",
    nameValueThreekit: "Medium Rectangle",
    subcategory: "Ottomans",
  },
  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Medium Square Ottoman",
    labelUI: "Medium Square Ottoman",
    nameValueThreekit: "Medium Square Ottoman",
    subcategory: "Ottomans",
  },
  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Large Circle",
    labelUI: "Large Circle",
    nameValueThreekit: "Large Circle",
    subcategory: "Ottomans",
  },
  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Large Rectangle",
    labelUI: "Large Rectangle",
    nameValueThreekit: "Large Rectangle",
    subcategory: "Ottomans",
  },
  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Medium Circle",
    labelUI: "Medium Circle",
    nameValueThreekit: "Medium Circle",
    subcategory: "Ottomans",
  },
  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Large Square Ottoman",
    labelUI: "Large Square Ottoman",
    nameValueThreekit: "Large Square Ottoman",
    subcategory: "Ottomans",
  },
];
